import { Box, IconButton, Modal, Stack, Typography } from '@mui/material';
import ProfileUserCard from '../userRegistration/ProfileUserCard';
import { UserProfileDto } from '@inosio/payments-sdk';
import CloseModalIcon from '../../icons/RoundCloseIcon.svg';
import RegisteredBlueIcon from '../../icons/Registered_Blue.svg';

interface LogAsProfileUserModalProps {
  open: boolean;
  onClose: () => void;
  profileUsers: UserProfileDto[];
  profileUuid: string;
}
export const LogAsProfileUserModal = (props: LogAsProfileUserModalProps) => {
  return (
    <Box>
      <Modal open={props.open} onClose={props.onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box
          sx={{
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 520,
            background: '#FFFFFF',
            boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
            borderRadius: '24px',
            p: 4,
            outline: 'none',
            minHeight: '523px',
          }}
        >
          <Stack direction="column" justifyContent="start" alignItems="space-between" spacing={2}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} sx={{ position: 'relative' }}>
              <Typography
                style={{
                  fontFamily: '"Work Sans",Sans serif',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  fontSize: '18px',
                  lineHeight: '22px',
                  color: '#14142B',
                  margin: '0 !important',
                }}
              >
                Select the user to log as
              </Typography>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="Close modal"
                onClick={props.onClose}
                sx={{
                  position: 'absolute',
                  right: 0,
                }}
              >
                <img src={CloseModalIcon} alt="close" />
              </IconButton>
            </Stack>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="center"
              spacing={3}
              sx={{
                maxHeight: '380px',
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  width: 7,
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                  borderRadius: '24px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'darkgrey',
                  borderRadius: '24px',
                },
              }}
            >
              {props.profileUsers.map((pu) => {
                return (
                  <ProfileUserCard
                    key={pu.UserUuid}
                    name={`${pu.FirstName || ''} ${pu.LastName || ''}`}
                    email={pu.UserEmail}
                    image={RegisteredBlueIcon}
                    onClick={() => {
                      window.open(`/login?logAsEntityUuid=${props.profileUuid}&logAsUserUuid=${pu.UserUuid || ''}`, '_blank');
                    }}
                  />
                );
              })}
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
};
export default LogAsProfileUserModal;
